import { Component, inject } from '@angular/core';
import { TermsAndConditionsService } from '../terms-and-conditions/service/terms-and-conditions.service';
import { TermsAndConditionsTypeEnum } from '@well/domain';
import { map } from 'rxjs/operators';

@Component({
    selector: 'well-guest-terms-and-conditions-page',
    templateUrl: './guest-terms-and-conditions-page.component.html',
    styleUrl: './guest-terms-and-conditions-page.component.scss',
    standalone: false
})
export class GuestTermsAndConditionsPageComponent {
  termsAndConditionsDto$ = inject(TermsAndConditionsService)
    .getTermsAndConditions(TermsAndConditionsTypeEnum.PLATFORM)
    .pipe(map((resource) => resource.data));
}
